<template>
  <div class="loginWrapper">
    <div class="container-fluid">
      <div class="row flex">
        <div class="col-md-6 loginPageImageWrapper">
        </div>
        <div class="col-md-6 loginContentWrapper">
          <div class="loginContentInnerWrapper">
          <div class="row">
            <div class="col-md-9 offset-md-2 text-center">
                <img src="@/assets/img/hagens-akeri-logo.png"/>
                <p class="ingress"></p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-9 offset-sm-2">
              <div class="loginFormWrapper">
              <form @submit.prevent="login">
                <div class="form-group">
                  <input type="text" v-model="user.email" name="username"
                    placeholder="Användarnamn"
                    class="form-control"
                    required>
                  <div class="invalid-feedback" style="display: none;">
                    Användarnamn är obligatoriskt</div>
                  </div>
                <div class="form-group">
                  <input type="password" v-model="user.password"
                    name="password"
                    placeholder="Lösenord"
                    class="form-control"
                    required>
                  <div class="invalid-feedback" style="display: none;">Lösenord är obligatoriskt</div>
                </div>
                <div class="form-group formLoginButtons">
                  <button class="btn btn-primary">Logga in</button>
                  <!-- <button class="btn btn-primary forgotPasswordBtn">Glömt lösenord?</button> -->
                </div>
                <div v-if="inValidError !=''" class="onErrorValidationWrapper">
                    <p class="text-danger">{{inValidError}}</p>
                </div>
              </form>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
export default {
  name: 'Login',
  data () {
    return {
      header: 'Logga in',
      inValidError: '',
      user: {
        email: '',
        password: ''
      }
    }
  },
  components: {
  },
  mounted () {
    this.isLoggedIn()
  },
  methods: {
    login: function () {
      let email = this.user.email
      let password = this.user.password
      this.$store.dispatch('login', { email, password })
        .then(() => {
          bus.$emit('loggedIn', true)
          if (localStorage.getItem('role') === 'Extern') {
            bus.$emit('role', localStorage.getItem('role'))
            this.$router.push('/planningexternal')
          } else {
            bus.$emit('role', localStorage.getItem('role'))
            this.$router.push('/planning')
          }
        })
        .catch(err => {
          console.log(err)
          this.inValidError = 'Felaktigt namn eller lösenord'
        })
    },
    isLoggedIn: function () {
      if (localStorage.getItem('token') !== null) {
        const token = localStorage.getItem('token') || ''
        const decodedToken = this.$jwtDec.decode(token)
        let loggedIn = (Date.now() / 1000) < decodedToken.exp
        if (loggedIn) {
          this.$router.push('/planning')
        }
      }
    }
  }
}
</script>

 <style scoped>
  .loginFormWrapper
  {
    text-align:center;
  }

  .form-control[type="text"],
  .form-control[type="password"],
  .form-control:focus
  {
    border: none;
    border-bottom: solid 2px #E9E9F0;
    width: 400px;
    max-width: 100%;
    margin:auto;
  }

  .btn.btn-primary
  {
    background: #E8665A;
    width: 185px;
  }

  .btn.btn-primary:hover
  {
    background: #D05B50;
  }

  .formLoginButtons
  {
    margin-top: 60px;
  }

  .formLoginButtons button:first-child
  {
    margin-right: 30px;
  }

.loginWrapper {
  background-image: url("../assets/img/gruppbild.jpg");
  background-size: cover;
  background-position: center;
}

.loginWrapper .flex
{
    height: 100vh;
    background: transparent;
}

.loginContentWrapper
{
    align-self: center;
    height: 100%;
    align-items: center;
    display:flex;
}

.loginContentWrapper img
{
    margin-bottom: 45px;
}

.loginContentInnerWrapper {
    background: rgba(255,255,255,0.8);
    padding: 2rem;
    width: 600px;
    border-radius: 15px;
}

.loginContentWrapper p.ingress
{
    color: #5D5D5D;
    width: 800px;
    margin: auto;
    margin-bottom: auto;
    margin-bottom: 45px;
    max-width: 100%;
}

.btn.btn-primary.forgotPasswordBtn
{
  background: #fff;
  color: #5D5D5D;
  border: solid 1px #E8665A;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue